import { create } from 'zustand';

/**
 * "Giriş akışı hâlâ sürüyor" bayrağı.
 *
 * `login()` çözülür çözülmez oturum "authenticated" oluyor ve /login rotasını saran
 * `AnonymousOnly` kullanıcıyı anında içeri alıyordu; lisans kapısı (abonelik bitti,
 * web lisansı yok) ekranda hiç görünmeden geçiliyordu. Bayrak açıkken hem sayfa hem
 * koruyucu yönlendirmeyi bekletir.
 *
 * Store olmasının sebebi: bayrağı hem giriş sayfası hem de rota koruyucusu okuyor ve
 * ikisi farklı ağaçlarda duruyor.
 */
interface LoginGateState {
  /** Giriş isteği + lisans kapısı bitene kadar true */
  pending: boolean;
  setPending: (v: boolean) => void;
}

export const useLoginGate = create<LoginGateState>((set) => ({
  pending: false,
  setPending: (pending) => set({ pending }),
}));
